export const DASHBOARD_ROUTES = {
  home: '/dashboard',
  progress: '/dashboard/progress',
  examCategories: '/dashboard/exam-categories',
  selectExams: '/dashboard/exam-categories/exams',
  preview: '/dashboard/preview',
  states: '/dashboard/states',
  favoriteExams: '/dashboard/favorite-exams',
};
